import { useEffect, useState } from "react";
import _ from "underscore";

import { Editor } from "react-draft-wysiwyg";
import { EditorState, ContentState, convertToRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

export const PaymentServiceTerms = (props) => {
  const [editorStateEN, setEditorStateEN] = useState(EditorState.createEmpty());
  const [editorStateSE, setEditorStateSE] = useState(EditorState.createEmpty());
  const [editorStateFI, setEditorStateFI] = useState(EditorState.createEmpty());
  const [version, setVersion] = useState("");

  useEffect(() => {
    props.getPaymentServiceTerms();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (props.terms.paymentServiceTerms.fetched) {
      let latestTerms = _.sortBy(
        props.terms.paymentServiceTerms.data,
        (terms) => terms.Version,
      ).at(-1);
      setVersion(latestTerms.Version);
      buildContentState(props.terms.paymentServiceTerms);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.terms.paymentServiceTerms.fetching]);

  return (
    <div
      style={{
        padding: "6px 5px 0",
        borderRadius: "2px",
        border: "1px solid #F1F1F1",
        background: "white",
      }}
    >
      <input type="text" value={version} onChange={changeVersion} />
      <input
        type="button"
        value="Send terms"
        onClick={sendNewVersion.bind(this, false)}
      />
      <input
        style={{ float: "right" }}
        type="button"
        value="Send terms without versioning"
        onClick={sendNewVersion.bind(this, true)}
      />
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <h3>English</h3>
        </AccordionSummary>
        <AccordionDetails>
          <Editor
            editorState={editorStateEN}
            onEditorStateChange={(editorState) => setEditorStateEN(editorState)}
          />
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <h3>Swedish</h3>
        </AccordionSummary>
        <AccordionDetails>
          <Editor
            editorState={editorStateSE}
            onEditorStateChange={(editorState) => setEditorStateSE(editorState)}
          />
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <h3>Finish</h3>
        </AccordionSummary>
        <AccordionDetails>
          <Editor
            editorState={editorStateFI}
            onEditorStateChange={(editorState) => setEditorStateFI(editorState)}
          />
        </AccordionDetails>
      </Accordion>
    </div>
  );

  function buildContentState(props) {
    const lastTerms = _.sortBy(props.data, (terms) => terms.Version).at(-1);
    setEditorStateEN(buildEditorState(lastTerms.ContentEN));
    setEditorStateSE(buildEditorState(lastTerms.ContentSE));
    setEditorStateFI(buildEditorState(lastTerms.ContentFI));
    setVersion(lastTerms.Version);
  }

  function buildEditorState(content) {
    const blocksFromHtml = htmlToDraft(content);
    return EditorState.createWithContent(
      ContentState.createFromBlockArray(blocksFromHtml.contentBlocks),
    );
  }

  function sendNewVersion(ignoreVersioning) {
    const contentEN = convertToRaw(editorStateEN.getCurrentContent());
    const contentSE = convertToRaw(editorStateSE.getCurrentContent());
    const contentFI = convertToRaw(editorStateFI.getCurrentContent());

    const contents = {
      EN: draftToHtml(contentEN),
      SE: draftToHtml(contentSE),
      FI: draftToHtml(contentFI),
    };
    props.sendNewPaymentServiceTerms(contents, version, ignoreVersioning);
  }

  function changeVersion(event) {
    setVersion(event.target.value);
  }
};

export default PaymentServiceTerms;
